var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "30%", height: "30%" },
          attrs: {
            title: _vm.title,
            width: 500,
            visible: _vm.visible,
            "confirm-loading": _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "请输入数量",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["number", _vm.validatorRules.number],
                            expression: "[ 'number', validatorRules.number]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入数量" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }